module.exports = __webpack_public_path__ + "img/visa-icon.404e9f19.png";